import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-fullscreen-loading',
  imports: [],
  templateUrl: './fullscreen-loading.component.html',
  styleUrl: './fullscreen-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullscreenLoadingComponent {}
